export const APP_VERSION = 12;

function isAppVersionLower() {
    let storedVersion = localStorage.getItem('lastSeenVersion');
    return (storedVersion === null || parseInt(storedVersion, 10) < APP_VERSION)
}

export function storeNewVersion() {
    localStorage.setItem('lastSeenVersion', APP_VERSION.toString());
    // does not exist on LGTV
    document.getElementById("settings_button")?.classList.remove("new-feature");
}

export function setupNewFeatureIndicator() {
    if (isAppVersionLower()) {
        // does not exist on LGTV
        document.getElementById("settings_button")?.classList.add("new-feature")
    }
}